"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Icon_1 = __importDefault(require("@material-ui/core/Icon"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/authentication/actions");
var AccessibleDisabledButton_1 = __importDefault(require("../../../shared/components/button/AccessibleDisabledButton"));
var framework_1 = require("../../../widgets/framework");
var styles_2 = __importDefault(require("./styles"));
var validations_1 = require("./validations");
var ForgotPasswordForm = function (_a) {
    var _b;
    var email = _a.email, setEmail = _a.setEmail;
    var t = (0, react_i18next_1.useTranslation)().t;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_1.useState)(false), formIsValid = _c[0], setFormIsValid = _c[1];
    var _d = (0, react_1.useState)(false), error = _d[0], setError = _d[1];
    var _e = (0, react_1.useState)(false), focused = _e[0], setFocused = _e[1];
    var emailField = {
        type: 'email',
        key: 'email',
        value: email,
        isRequired: true,
        get fieldValue() {
            return email;
        },
        label: t('forgotPassword.email')
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, actions_1.sendPasswordResetInstructions)(email));
            return [2];
        });
    }); };
    var onFieldChange = function (value) {
        setEmail(value);
        setFormIsValid(validations_1.forgotPasswordSchema.isValidSync({ email: value }));
        setFocused(true);
        setError(false);
    };
    var onBlur = function () {
        setError(!formIsValid);
        setFocused(false);
    };
    var onFocus = function () {
        setFocused(true);
    };
    var labelColor = focused
        ? colorsV2_1.default.palette.primaryP500.hex()
        : colorsV2_1.default.palette.neutralsN700.hex();
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: __assign(__assign({}, theme.typography.body2), { padding: theme.spacing(0, 2), gap: '2px', color: error ? (_b = colorsV2_1.default.commonColors.error) === null || _b === void 0 ? void 0 : _b.hex() : labelColor })
    };
    var onNavigate = function () {
        var appNavigate = {
            action: 'REGISTER'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(Typography_1.default, { color: "textPrimary", variant: "body1" }, t('forgotPassword.text1'))),
        react_1.default.createElement("div", { className: classes.inputContainer },
            react_1.default.createElement(Typography_1.default, { variant: "body2", style: {
                    color: colorsV2_1.default.palette.neutralsN900.hex()
                } }, t('forgotPassword.required')),
            react_1.default.createElement("div", { className: classes.form },
                react_1.default.createElement(package_1.FieldRenderer, { field: emailField, onChange: onFieldChange, labelProps: labelProps, inputProps: {
                        autoComplete: "email",
                        fullWidth: true,
                        variant: constants_1.default.FIELDS_VARIANT,
                        onBlur: onBlur,
                        onFocus: onFocus,
                        style: {
                            gap: theme.spacing(1)
                        },
                        error: error,
                        helperText: error ? t('forgotPassword.error') : null
                    } }))),
        react_1.default.createElement("div", { className: classes.submit },
            react_1.default.createElement(AccessibleDisabledButton_1.default, { className: classes.submitButton, classes: { disabled: classes.disabledSubmitButton }, type: "submit", size: "large", variant: "contained", fullWidth: true, disabled: !formIsValid, color: "primary", onClick: onSubmit }, t('forgotPassword.submitBtn'))),
        react_1.default.createElement("div", { className: classes.register },
            react_1.default.createElement(Typography_1.default, { color: "textPrimary", variant: "body2", style: { alignSelf: 'stretch', textAlign: 'center' } }, t('forgotPassword.text3')),
            react_1.default.createElement(Button_1.default, { onClick: onNavigate, component: "a", className: classes.registerButton },
                react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.primaryText }, t('forgotPassword.registerBtn')),
                react_1.default.createElement(Icon_1.default, { color: "primary" }, "how_to_reg")))));
};
exports.default = ForgotPasswordForm;
//# sourceMappingURL=ForgotPasswordForm.js.map